import { OrderStatus } from '@/types/order';
import { Button, Col, Form, Input, Row, Select, Space } from 'antd';
import { useAtom } from 'jotai';
import {
  loadProductCategories,
  productCategoriesAtom,
  ProductCategory,
} from '@/atoms/productCategories';
import type { FormInstance } from 'antd/es/form';
import { useEffect, useState } from 'react';
import { commonOptionsAtom } from '@/atoms/commonOptions';

interface SearchFormProps {
  onSearch: () => void;
  form: FormInstance;
  onReset: () => void;
}

const SearchForm = ({ onSearch, form, onReset }: SearchFormProps) => {
  const [categories] = useAtom(productCategoriesAtom);

  return (
    <Form
      form={form}
      size="small"
      onFinish={onSearch}
      style={{ width: '100%' }}
    >
      <Row gutter={[16, 8]}>
        <Col xs={24} sm={12} lg={8}>
          <Form.Item
            name="orderId"
            label="订单ID"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Input allowClear placeholder="请输入订单ID" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Form.Item
            name="productTitle"
            label="商品名称"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Input allowClear placeholder="请输入商品名称" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Form.Item
            name="userNumber"
            label="SUPP ID"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Input allowClear placeholder="请输入SUPP ID" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Form.Item
            name="userName"
            label="用户名"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Input allowClear placeholder="请输入用户名" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Form.Item
            name="orderStatus"
            label="订单状态"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Select
              allowClear
              placeholder="请选择订单状态"
              options={[
                { label: '全部', value: '' },
                { label: '已创建', value: OrderStatus.Created },
                { label: '待发货', value: OrderStatus.ToShip },
                { label: '待收货', value: OrderStatus.ToReceive },
                { label: '已完成', value: OrderStatus.Completed },
                { label: '已取消', value: OrderStatus.Canceled },
                { label: '已退款', value: OrderStatus.Refunded },
                { label: '已删除', value: OrderStatus.Deleted },
              ]}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Form.Item
            name="productCategoryId"
            label="产品类型"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
          >
            <Select
              allowClear
              placeholder="请选择产品类型"
              options={[
                { label: '全部', value: '' },
                ...(categories?.map((category) => ({
                  label: category.categoryTitle,
                  value: category.productCategoryId,
                })) || []),
              ]}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row justify="end" style={{ marginTop: 24, marginBottom: 24 }}>
        <Col>
          <Space size="middle">
            <Button onClick={onReset}>重置</Button>
            <Button type="primary" htmlType="submit">
              搜索
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default SearchForm;
